import { render, staticRenderFns } from "./WdcCampaignRecord.vue?vue&type=template&id=30cc7cf0&"
import script from "./WdcCampaignRecord.vue?vue&type=script&lang=js&"
export * from "./WdcCampaignRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports